import { useMutation } from "@tanstack/react-query";
import { saveDotdigitalMappings } from "../../api/bDotdigitalApi";

export const useSaveDotdigitalMappings = () => {
  return useMutation({
    mutationKey: ["save-dotdigital-mappings"],
    mutationFn: (data) => saveDotdigitalMappings(data),
    onError: (error) => {
      console.error("Dotdigital mapping save error:", error.response || error);
    },
  });
};
